/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { opportunitySchema } from './opportunity-schema';

export const eventSchema: z.AnyZodObject = z.object({
  attachmentKey: z.string().nullish(),
  attachmentName: z.string().nullish(),
  bullhornNoteId: z.string().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  description: z.string().nullish(),
  emailAddresses: z.array(z.string()).nullish(),
  id: z.string().uuid(),
  integrationId: z.string().nullish(),
  lastAuthoredBy: z.string().uuid().nullish(),
  lastUpdatedBy: z.string().uuid().nullish(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  purpose: z.string().nullish(),
  salesforceEventId: z.string().nullish(),
  scheduledDate: z.string().date().nullish(),
  type: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type Event = z.infer<typeof eventSchema>;
